<div class="flex flex-col gap-4 h-full">
  <h1>Batch</h1>
  <p-tabs value="jobs" class="flex-1 border-1 overflow-hidden">
    <p-tablist>
      <p-tab value="jobs"><i class="pi pi-search"></i> Kørte jobs</p-tab>
      <p-tab value="schedules"
        ><i class="pi pi-list"></i> Næste planlagte jobs
      </p-tab>

      @if (allowEdit()) {
        <div class="mt-2 ml-8">
          <p-button
            label="Opret batchjob"
            icon="pi pi-plus"
            (click)="opretBatchjob()"></p-button>
        </div>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="jobs">
        <div class="flex flex-col overflow-hidden h-full">
          <div class="mb-4">
            <div class="text-lg font-medium mb-2">Søgning</div>
            <app-batch-search />
          </div>
          <app-batch-job-status />
          <div class="text-lg font-medium mb-2">Kørte jobs</div>
          <div class="flex-1 overflow-hidden">
            <app-batch-job />
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="schedules">
        <app-batch-job-schedule />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
@if (allowEdit()) {
  <p-dialog
    header="Opret batchjob"
    [modal]="true"
    (onHide)="onHideOpretJob()"
    [(visible)]="showOpret"
    appendTo="body"
    contentStyleClass="!overflow-hidden h-full"
    [style]="{
      width: '80%',
      maxHeight: '90%',
      maxWidth: '1400px',
      height: '80%',
    }">
    <app-batch-job-schedule-detail
      (closeWindowRequest)="showOpret.set(false)" />
  </p-dialog>
}
